import Vue from "vue";
import Router from "vue-router";

// Components
import Error from "@/components/ComponentError";
import PublicFAQ from "@/components/ComponentPublicFAQ";

// Pages
import Homepage from "@/layouts/LayoutHome";
import PageNotFound from "@/pages/PageNotFound";
import PageAbout from "@/pages/PageAbout";
import AlgemeneVoorwaarden from "@/pages/PageAlgVoorw";
import PageBlogPage from "@/pages/PageBlogPage";
import PageWoningForSale from "@/pages/PageWoningForSale";
import PageProvincy from "@/pages/PageProvincy";
import PageCity from "@/pages/PageCity";
import PageOverview from "@/pages/PageOverview";
import PageWoningForRent from "@/pages/PageWoningForRent";
import PageExplain from "@/pages/PageExplain";


// Import store
import store from "@/store";
import { token } from "../helpers/get-token";
import PageFunnel from "../pages/PageFunnel.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    { path: "*", component: PageNotFound },
    {
      path: "/",
      name: "Homepage",
      component: Homepage,
      props: { layout: { full: false } },
      meta: {
        title: "iSalu helpt jou om je zelfverzekerd te bewegen op de woningmarkt",
        metaTags: [
          { name: 'description', content: 'iSalu helpt jou om je zelfverzekerd te bewegen op de woningmarkt' },
          { property: 'og:description', content: 'iSalu helpt jou om je zelfverzekerd te bewegen op de woningmarkt' },
          { property: 'og:title', content: 'iSalu helpt jou om je zelfverzekerd te bewegen op de woningmarkt'},
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/isaluAssets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'iSalu helpt jou om je zelfverzekerd te bewegen op de woningmarkt' },
          { n: 'twitter:description', c: 'iSalu helpt jou om je zelfverzekerd te bewegen op de woningmarkt'}, 
          { itemprop: 'name', content: 'iSalu helpt jou om je zelfverzekerd te bewegen op de woningmarkt' },
          { itemprop: 'description', content: 'iSalu helpt jou om je zelfverzekerd te bewegen op de woningmarkt' },
        ]  
      }
    },
    {
      path: "/error",
      name: "Error",
      component: Error,
      props: { layout: { full: true } },
      meta: {
        title: "Fout"
      }
    },
    {
      path: "/woning/:funnel",
      name: "Woning",
      props: true,
      component: PageFunnel,
      meta: {
        title: "Zelfverzekerd op de woningmarkt",
        metaTags: [
          { name: 'description', content: 'Zelfverzekerd op de woningmarkt' },
          { property: 'og:description', content: 'Zelfverzekerd op de woningmarkt' },
          { property: 'og:title', content: 'Zelfverzekerd op de woningmarkt' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/woning/verkopen' },
          { property: 'og:image', content: '../src/isaluAssets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'Zelfverzekerd op de woningmarkt' },
          { n: 'twitter:description', c: 'Zelfverzekerd op de woningmarkt'}, 
          { itemprop: 'name', content: 'Zelfverzekerd op de woningmarkt' },
          { itemprop: 'description', content: 'Zelfverzekerd op de woningmarkt' },
        ]  
      }
    },
    {
      path: "/blog/:postTitle",
      name: "BlogPagina",
      props: true,
      component: PageBlogPage,
      meta: {
        title: "iSalu Blog",
        metaTags: [
          { name: 'description', content: 'iSalu Blog' },
          { property: 'og:description', content: 'iSalu Blog' },
          { property: 'og:title', content: 'iSalu Blog' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/isaluAssets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'iSalu Blog' },
          { n: 'twitter:description', c: 'iSalu Blog'}, 
          { itemprop: 'name', content: 'iSalu Blog' },
          { itemprop: 'description', content: 'iSalu Blog' },
        ]
      }
    },
    {
      path: "/provincy/:provincy",
      name: "Woningen te koop in provincy",
      props: true,
      component: PageProvincy,
      meta: {
        title: "Woningen te koop in provincy",
        metaTags: [
          { name: 'description', content: 'Woning te koop' },
          { property: 'og:description', content: 'Woning te koop' },
          { property: 'og:title', content: 'Woning te koop' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/assets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'Woning te koop' },
          { n: 'twitter:description', c: 'Woning te koop'}, 
          { itemprop: 'name', content: 'Woning te koop' },
          { itemprop: 'description', content: 'Woning te koop' },
        ]
      }
    },
    {
      path: "/stad/:stad",
      name: "Woningen te koop in stad",
      props: true,
      component: PageCity,
      meta: {
        title: "Woningen te koop in stad",
        metaTags: [
          { name: 'description', content: 'Woning te koop' },
          { property: 'og:description', content: 'Woning te koop' },
          { property: 'og:title', content: 'Woning te koop' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/assets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'Woning te koop' },
          { n: 'twitter:description', c: 'Woning te koop'}, 
          { itemprop: 'name', content: 'Woning te koop' },
          { itemprop: 'description', content: 'Woning te koop' },
        ]
      }
    },
    {
      path: "/:funnel/:step",
      name: "Toelichting",
      props: true,
      component: PageExplain,
      meta: {
        title: "Toelichting",
        metaTags: [
          { name: 'description', content: 'Toelichting voor verkoper' },
          { property: 'og:description', content: 'Toelichting voor verkoper' },
          { property: 'og:title', content: 'Toelichting voor verkoper' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/isaluAssets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'Toelichting voor verkoper' },
          { n: 'twitter:description', c: 'Toelichting voor verkoper'}, 
          { itemprop: 'name', content: 'Toelichting voor verkoper' },
          { itemprop: 'description', content: 'Toelichting voor verkoper' },
        ]
      }
    },
    {
      path: "/verhuur/:stad/:straat",
      name: "Woning te huur",
      props: true,
      component: PageWoningForRent,
      meta: {
        title: "Woning te huur",
        metaTags: [
          { name: 'description', content: 'Woning te huur' },
          { property: 'og:description', content: 'Woning te huur' },
          { property: 'og:title', content: 'Woning te huur' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/assets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'Woning te huur' },
          { n: 'twitter:description', c: 'Woning te huur'}, 
          { itemprop: 'name', content: 'Woning te huur' },
          { itemprop: 'description', content: 'Woning te huur' },
        ]
      }
    },
    {
      path: "/overzicht",
      name: "Woningen te koop in Nederland",
      props: false,
      component: PageOverview,
      meta: {
        title: "Woningen te koop in Nederland",
        metaTags: [
          { name: 'description', content: 'Woning te koop' },
          { property: 'og:description', content: 'Woning te koop' },
          { property: 'og:title', content: 'Woning te koop' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/assets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'Woning te koop' },
          { n: 'twitter:description', c: 'Woning te koop'}, 
          { itemprop: 'name', content: 'Woning te koop' },
          { itemprop: 'description', content: 'Woning te koop' },
        ]
      }
    },
    {
      path: "/:stad/:straat/:nr",
      name: "Woning te koop",
      props: true,
      component: PageWoningForSale,
      meta: {
        title: "Woning te koop",
        metaTags: [
          { name: 'description', content: 'Woning te koop' },
          { property: 'og:description', content: 'Woning te koop' },
          { property: 'og:title', content: 'Woning te koop' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/assets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'Woning te koop' },
          { n: 'twitter:description', c: 'Woning te koop'}, 
          { itemprop: 'name', content: 'Woning te koop' },
          { itemprop: 'description', content: 'Woning te koop' },
        ]
      }
    },
    {
      path: "/over-ons",
      name: "Over ons",
      component: PageAbout,
      meta: {
        title: "Over iSalu",
        metaTags: [
          { name: 'description', content: 'Makelaar' },
          { property: 'og:description', content: 'Makelaar' },
          { property: 'og:title', content: 'Makelaar' },
          { property: 'og:type', content: 'article' },
          { property: 'og:url', content: 'https://www.isalu.nl/' },
          { property: 'og:image', content: '../src/isaluAssets/img/isalu_logo.png' },
          { name: 'twitter:title', content: 'Makelaar' },
          { n: 'twitter:description', c: 'Makelaar'}, 
          { itemprop: 'name', content: 'Makelaar' },
          { itemprop: 'description', content: 'Makelaar' },
        ]
      }
    },
    {
      path: "/veelgestelde-vragen",
      name: "Veelgestelde vragen",
      component: PublicFAQ,
      meta: {
        title: "Veelgestelde vragen"
      }
    },
    {
      path: "/algemene-voorwaarden",
      name: "Algemene voorwaarden",
      component: AlgemeneVoorwaarden,
      props: true,
      meta: {
        title: "Algemene voorwaarden"
      }
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }  
});

export default router;

router.beforeEach((to, from, next) => {

  // check if the route requires authentication
  if(to.matched.some(route => route.meta.requiresAuth)) {
    store.dispatch("fetch").then(() => {
      if(store.state.loggedIn) {
        next();
      }
      else {
        next({ name: "Inloggen" });
      }
    })
  }

  if(to.path === "/gebruiker/dashboard" && store.state.status.loggedIn) {
    if(store.state.user.userType === 1) {
      next({ name: "Huis" });
      return;
    } else {
      next({ name: "DashboardSeller" });
      return;
    }
  }

  // check if the route requires address and user is not logged in
  if (
    (to.matched.some(route => route.meta.requiresAddress) &&
    (Object.keys(store.state.address).length === 0) && !token))
 {
    // redirect to login page
    next({ name: "Inloggen" });
    return;
  }

  // if logged in redirect to dashboard
  if (
    (to.path === "/gebruiker/inloggen" && store.state.status.loggedIn) ||
    (to.path === "/gebruiker/registreren" && store.state.status.loggedIn)
  ) {
    if(store.state.user.userType === 1) {
      next({ name: "Huis" });
      return;
    } else {
      next({ name: "DashboardSeller" });
      return;
    }
  }
  document.title = `iSalu - ${to.meta.title}`;

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});
